import { Component, HostListener, Input, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { OnDestroy } from '@angular/core';
import { AppState } from 'src/app/store/app.states';
import { ComponentBase } from 'src/app/views/component-base';
import { AsyncPipe, NgIf, NgTemplateOutlet } from '@angular/common';
import { AppButtonComponent } from '@ifaa-components/ui-components';
import { investments_IsManualSplit } from '../steps/nmj-investments/selectors';

@Component({
    selector: 'app-nmj-info-display',
    templateUrl: './nmj-info-display.component.html',
    styleUrls: ['./nmj-info-display.component.scss'],
    imports: [
        NgIf,
        AppButtonComponent,
        NgTemplateOutlet,
        AsyncPipe
    ],
})
export class NmjInfoDisplayComponent
    extends ComponentBase
    implements OnInit, OnDestroy {
    @HostListener('window:resize', ['$event'])
    onResize(_event) {
        this.innerWidth = window.innerWidth;
    }

    @Input() set step(value: number) {
        this.stepIndex = value;
    }
    @Input() set isCompleted(value: boolean) {
        this.completed = value;
    }

    isManualSplit$ = this.store.pipe(select(investments_IsManualSplit));

    innerWidth: any;
    stepIndex: number = 0;
    completed: boolean = false;

    constructor(public store: Store<AppState>) {
        super();
    }

    async ngOnInit() {
        super.ngOnInitBase();
        this.innerWidth = window.innerWidth;
    }

    ngOnDestroy(): void {
        super.ngOnDestroyBase();
    }

    goBackToHome() {
        window.location.href = 'https://vervesuper.com.au/';
    }
}
